import { useCallback, useEffect } from 'react';
import { User } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';
import { getCachedConfig } from '../lib/service-discovery';
/**
 * Hook to handle OIDC messages from auth popup
 *
 * This listens for messages from the auth popup window and updates
 * the local auth state when a user signs in.
 */
export function useOidcMessageHandler() {
    const { events } = useAuth();
    const handleMessage = useCallback(async (event) => {
        const config = getCachedConfig();
        if (!config) {
            console.warn('[OIDC] No cached config available for message handler');
            return;
        }
        const { authority, clientId } = config;
        if (event.data?.source === 'oidc-client' && event.data?.user !== null) {
            const user = User.fromStorageString(event.data.user);
            localStorage.setItem(`oidc.user:${authority}:${clientId}`, event.data.user);
            await events.load(user, true);
        }
    }, [events]);
    useEffect(() => {
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [handleMessage]);
}
